export default "__VITE_ASSET__Ci2NEmAb__"